import hello from "hellojs";

export default ({ Vue }) => {
  hello.init(
    { google: "821813471232-p18j9tbtia4o1t68jh0ci8v5bas2cseb.apps.googleusercontent.com" },
    {
      redirect_uri: window.location.origin + "/login",
      scope: "https://www.googleapis.com/auth/userinfo.email"
    }
  );
  Vue.prototype.$hello = hello;
};
